import "core-js/modules/es6.function.name";
import { getToken as _getToken, getUser } from '@/api/user';
import { getAccessToken, setToken, removeToken, setUserInfo, getUserInfo, removeUserInfo } from '@/utils/auth';
import { resetRouter } from '@/router';
import userIcon from '@/assets/user.png';
var state = {
  token: getAccessToken(),
  name: '',
  roleCode: '',
  userId: '',
  avatar: userIcon,
  userInfo: getUserInfo() || ''
};
var mutations = {
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_NAME: function SET_NAME(state, name) {
    sessionStorage.setItem('name', name);
    state.name = name;
  },
  SET_USER_INFO: function SET_USER_INFO(state, userInfo) {
    setUserInfo(userInfo);
    state.userInfo = userInfo;
  },
  SET_CODE: function SET_CODE(state, code) {
    sessionStorage.setItem('roleCode', code);
    state.roleCode = code;
  },
  SET_USER_ID: function SET_USER_ID(state, id) {
    sessionStorage.setItem('userId', id);
    state.userId = id;
  },
  SET_AVATAR: function SET_AVATAR(state, avatar) {
    state.avatar = avatar;
  }
};
var actions = {
  // 换取token
  getToken: function getToken(_ref, payload) {
    var commit = _ref.commit,
      state = _ref.state;
    return new Promise(function (resolve, reject) {
      _getToken({
        qrId: payload.qrId,
        userId: payload.userId,
        ticket: payload.ticket
      }).then(function (res) {
        commit('SET_TOKEN', res.data);
        setToken(res.data);
        resolve(res.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // get user info
  getInfo: function getInfo(_ref2) {
    var commit = _ref2.commit,
      state = _ref2.state;
    return new Promise(function (resolve, reject) {
      getUser().then(function (res) {
        commit('SET_USER_INFO', res.data);
        commit('SET_NAME', res.data.name);
        resolve();
      });
    });
  },
  // user logout
  logout: function logout(_ref3) {
    var commit = _ref3.commit,
      state = _ref3.state;
    commit('SET_TOKEN', '');
    commit('SET_NAME', '');
    commit('SET_CODE', '');
    commit('SET_USER_ID', '');
    commit('SET_USER_INFO', '');
    removeUserInfo();
    removeToken();
  },
  // remove token
  resetToken: function resetToken(_ref4) {
    var commit = _ref4.commit;
    return new Promise(function (resolve) {
      commit('SET_TOKEN', '');
      removeToken();
      resolve();
    });
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};